export const isDebugEnabled = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('debug') === 'true';
};
